// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"d39d4937","202":"5ab43aba","222":"b8fae4c0","284":"2ed01794","541":"2946df85","594":"f090a76e","651":"08e7b901","674":"2fe265a0","759":"dbba81ae","841":"0831fc4a","874":"ce446a59","967":"faf60cbb"}[chunkId] + ".chunk.js";
};